import React, { useState, useEffect } from "react";
import firebase, { getDb } from "src/utils/firebase";
import { QRCodeSVG } from "qrcode.react";
import { Button, Box, Typography, Paper } from "@mui/material";
import ItarraLogo from "src/assets/images/itarra.svg"; // ✅ make sure the logo exists here

const UserProfileQR = () => {
  const [user, setUser] = useState(null);
  const [userDoc, setUserDoc] = useState({});

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (u) => {
      if (u) {
        setUser(u);
        try {
          const db = getDb();
          const docRef = db.collection("users").doc(u.uid); // assumes doc id = uid
          const docSnap = await docRef.get();
          if (docSnap.exists) {
            setUserDoc(docSnap.data());
          }
        } catch (err) {
          console.error("Error fetching user doc:", err);
        }
      } else {
        setUser(null);
        setUserDoc({});
      }
    });
    return () => unsubscribe();
  }, []);

  const login = async () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    try {
      await firebase.auth().signInWithPopup(provider);
    } catch (error) {
      console.error("Login error", error);
    }
  };

  // Build vCard string from Firestore fields
  const getVCard = () => {
    return `BEGIN:VCARD
VERSION:3.0
FN:${userDoc.username || user?.displayName || ""}
EMAIL:${userDoc.email || user?.email || ""}
TEL:${userDoc.phone || ""}
TITLE:${userDoc.jobtitle || ""}
ORG:${userDoc.role || "iTarra"}
ADR:${userDoc.location || ""}
END:VCARD`;
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
      <Paper sx={{ p: 4, textAlign: "center", width: 420 }}>
        {/* ✅ Logo */}
        <Box sx={{ mb: 3 }}>
          <img src={ItarraLogo} alt="iTarra Logo" style={{ height: 60 }} />
        </Box>

        {!user ? (
          <>
            <Typography variant="h6">Login to see your QR Business Card</Typography>
            <Button variant="contained" color="primary" onClick={login} sx={{ mt: 2 }}>
              Login with Google
            </Button>
          </>
        ) : (
          <>
            {/* ✅ User Details */}
            <Typography variant="h6">{userDoc.username || user.displayName}</Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {userDoc.email || user.email}
            </Typography>
            {userDoc.phone && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                📱 {userDoc.phone}
              </Typography>
            )}
            {userDoc.jobtitle && (
              <Typography variant="body2" sx={{ mb: 1 }}>
                💼 {userDoc.jobtitle}
              </Typography>
            )}
            {userDoc.role && (
              <Typography variant="body2" sx={{ mb: 2 }}>
                🏢 {userDoc.role}
              </Typography>
            )}

            {/* ✅ QR Code only */}
            <QRCodeSVG value={getVCard()} size={220} includeMargin />
          </>
        )}
      </Paper>
    </Box>
  );
};

export default UserProfileQR;
